import React, { useState } from "react"
import { Avatar, Button, Menu, MenuItem, Tooltip, Typography, } from "@mui/material"
import { SITUACAO_PEDIDO, SITUACAO_PEDIDO_COR, } from "../../../../../utils/PedidoUtil"
import { useSnackbar } from "notistack"
import AuthService from "../../../../../AuthService"

const TIPOS_RETIRADA = ["RETIRAR_LOCAL", "CONSUMIR_LOCAL"]

const MenuSituacao = ({ pedido, handleCancel }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  const isPickup = TIPOS_RETIRADA.includes(pedido.tipoDelivery)

  const getStatusConfig = (situacao) => {
    const isReadyForPickup = situacao === "ENVIADO" && isPickup
    const baseLabel = SITUACAO_PEDIDO[situacao] || ""

    return {
      initials: isReadyForPickup ? "PR" : baseLabel.substring(0, 2),
      label: isReadyForPickup ? "PRONTO PARA BUSCAR" : baseLabel,
      menuActionLabel: isReadyForPickup ? "MARCAR COMO PRONTO PARA BUSCAR" : `MARCAR COMO ${situacao}`,
      color: SITUACAO_PEDIDO_COR[situacao],
    }
  }

  const currentStatus = getStatusConfig(pedido.situacao)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChangeSituacao = (pedido, situacao) => {
    if (situacao === "CANCELADO") {
      handleCancel(pedido)
      handleClose()
      return
    }

    const service = new AuthService()
    service.post(`/pedido/situacao/${pedido.id}/${situacao}`)
      .then((ped) => {
        pedido.situacao = ped.situacao
        enqueueSnackbar(`Situação alterada para ${isPickup && ped.situacao === "ENVIADO" ? "PRONTO PARA BUSCAR" : ped.situacao} com sucesso`, {
          variant: "success",
        })
        handleClose()
      })
      .catch((err) => {
        if (err.response) {
          err.response.json().then((elem) => {
            enqueueSnackbar(elem.errorMessage, { variant: "error" })
          })
        }
      })
  }

  const renderMenuItem = (situacao) => {
    const config = getStatusConfig(situacao)

    return (
      <MenuItem
        onClick={() => handleChangeSituacao(pedido, situacao)}
        key={situacao}
      >
        <Avatar
          sx={{
            backgroundColor: config.color,
            width: 32,
            height: 32,
            fontSize: "0.875rem",
          }}
        >
          {config.initials}
        </Avatar>
        <Typography sx={{ marginLeft: 2, fontSize: "0.9rem" }}>
          {config.menuActionLabel}
        </Typography>
      </MenuItem>
    )
  }

  return (
    <>
      <Tooltip title={currentStatus.label} placement="bottom">
        <Avatar
          sx={{ backgroundColor: currentStatus.color }}
          className={pedido.situacao === "PENDENTE" ? "pendenteAnimation" : ""}
        >
          <Button
            sx={{
              minWidth: "auto",
              padding: 0,
              color: "white",
              fontSize: "1.25rem",
              width: "100%",
              height: "100%",
            }}
            onClick={handleClick}
          >
            {currentStatus.initials}
          </Button>
        </Avatar>
      </Tooltip>

      <Menu
        id="menu-situacao"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: { minWidth: '250px' }
          }
        }}
      >
        {renderMenuItem("PENDENTE")}
        {renderMenuItem("CONFIRMADO")}
        {renderMenuItem("ENVIADO")}
        {renderMenuItem("ENTREGUE")}
        {renderMenuItem("CANCELADO")}
      </Menu>
    </>
  )
}

export default MenuSituacao